module.exports = __webpack_public_path__ + "img/Unusable.01c8c9b7.svg";